/**
 * Consider to move to 'form' package
 */
hrd.utils.buildSelect = function(id, sProvider, oSettings) {
	let fallbackKeyProperty = (typeof sProvider == 'function') ? 'key' : 'id';
	let fallbackLabelProperty = (typeof sProvider == 'function') ? 'label' : 'description';
	
	var keyProperty = (oSettings && oSettings.keyProperty) ? oSettings.keyProperty : fallbackKeyProperty;
	var labelProperty = (oSettings && oSettings.labelProperty) ? oSettings.labelProperty : fallbackLabelProperty;
	var alternateProperty = (oSettings && oSettings.alternateProperty) ? oSettings.alternateProperty : undefined;
	var defaultSettings = {
		fnOptionLabel: function(index, item) {
			var label;
			if (typeof labelProperty === 'function') {
				label = labelProperty(item, index);
			} else if (typeof labelProperty === 'string' && labelProperty != 'description') {
				label = item[labelProperty];
			} else {
				label = (item.name) ? item.name : item.description; // for backward compatibility
			}
			this.options[item[keyProperty]] = oSettings.keepLabelCase ? label : label;
		},
		keepList: false,
		keepProviderData: false,
		emptyList: false,
		onChange: $.noop,
		sorting: true,
		extraArgs: {},
		optionExtraData: [],
		initialValue: null,
		ignoreIsSelectedAttribute: false
	};
	oSettings = $.extend({}, defaultSettings, oSettings);

	var $combo = $(id);
	var deferred = $.Deferred();
	$combo.data('loaded', deferred.promise());

	// different provider behavior depending on sProvider type
	if (typeof sProvider == 'function') {
		var providerPromise = $.when(sProvider()); // convert result to promise

		providerPromise.then(function(opts) {
			var options = opts;
			let isArray = $.isArray(options);

			if (oSettings.emptyList) {
				$combo.removeOption(/./); // removes all options before start adding the new ones
			}

			if (isArray) {
				options.forEach(option => {
					$combo.addOption(option[keyProperty], option[labelProperty], false);

					let currentOption = $.grep($combo.options(), (opt) => opt.value == option[keyProperty])[0];
					$(currentOption).data('disabled', option.isDisabled);
					$(currentOption).data('ref-item', option);
				});

				// apply disabled stuff
				let disabledOptions = $combo.options().get().filter((opt) => $(opt).data('disabled') === true).map((opt) => $(opt).val());
				if (disabledOptions.length > 0) {
					$combo.disableOptions(disabledOptions, false);
				}

			} else {
				$combo.addOption(options, false);
			}


			$combo.on('change', function(event) {
				oSettings.onChange(event, $combo);
			});

			if (oSettings.keepList) {
				$combo.data('full-list', options);
			}
			if (!oSettings.noSort) {
				$combo.sortOptions(oSettings.sorting);
			}

			if (isArray) {
				/* this code is needed for storing in option.data some extra properties read from json row */
				if (oSettings.optionExtraData.length > 0) {
					var validOptions = $.grep($combo.options(), function(opt) { return opt.value !== ''; });
					$.each(oSettings.optionExtraData, (i, extraProp) => {
						var values = {};
						options.forEach(opt => {
							values[`kp_${opt[keyProperty]}`] = opt[extraProp];
						});
						$.each(validOptions, (_, option) => {
							var v = values[`kp_${option.value}`];
							$(option).data(extraProp, v);
							$(option).data(`extra-${extraProp}`, v);
						});
					});
				}
			}

			if (oSettings.initialValue != undefined) {
				$combo.selectOptions(oSettings.initialValue);
			} else {
				var initialList = [];
				if (initialList.length > 0) {
					$combo.selectOptions(initialList);
				}
			}

			$.each($combo.selectedOptions(), function(i, option) {
				var $opt = $(option);
				if ($opt.attr('value') !== undefined) {
					$opt.data('initially-selected', true);
				}
			});
			deferred.resolve($combo);
		});
	} else {
		var args = {
			sProvider: sProvider,
			iPageSize: -1, // valore 0 o negativo implica richiedere TUTTI i records
			iDisplayStart: 0
		};

		args = $.extend(args, oSettings.extraArgs);
		var prv = sProvider ? sProvider.substring(sProvider.lastIndexOf('.') + 1) : undefined;

		var settings = {
			url: hrd.globals.datatableURI + (prv ? '?_=' + prv : ''),
			dataType: 'json',
			data: args
		};

		if (hrd.globals.apiKey != undefined) {
			settings.headers = {
				"Api-Key": hrd.globals.apiKey
			};
		}
		if (hrd.globals.apiKeyExt != undefined) {
			settings.headers = {
				"Api-Key-Ext": hrd.globals.apiKeyExt
			};
		}
		if (hrd.globals.apiKeyUser != undefined) {
			settings.headers = {
				"Api-Key-User": hrd.globals.apiKeyUser
			};
		}
		$.ajax(settings).then(function(data) {
			var options = {};
			$.each(data.aaData, $.proxy(oSettings.fnOptionLabel, { options: options }));
			if (oSettings.emptyList) {
				$combo.removeOption(/./); // removes all options before start adding the new ones
			}

			let addedFakeEntry;
			if ($combo.options().length == 0) {
				// add fake option
				$combo.addOption('fake', 'fake', false);
				addedFakeEntry = true;
			}


			/* do not use options object because it looses 'natural' sorting */
			data.aaData.forEach((item, index) => {
				var label;

				if (typeof labelProperty === 'function') {
					label = labelProperty(item, index);
				} else if (typeof labelProperty === 'string' && labelProperty != 'description') {
					label = item[labelProperty];
				} else {
					label = (item.name) ? item.name : item.description; // for backward compatibility
				}
				label = oSettings.keepLabelCase ? label : label; // useless!!! to be fixed
				$combo.addOption(item[keyProperty], label, false);

				let currentOption = $.grep($combo.options(), (opt) => opt.value == item[keyProperty])[0];
				$(currentOption).data('disabled', item.isDisabled);
				$(currentOption).data('ref-item', item);
			});

			if (addedFakeEntry) {
				$combo.removeOption('fake');
			}

			// apply alternate stuff
			if (alternateProperty != undefined) {
				$combo.options().get().forEach(opt => {
					let item = $(opt).data('ref-item');
					if (item != undefined) {
						$(opt).attr('data-display', item[alternateProperty]);
					}
				});
			}

			// apply disabled stuff
			let disabledOptions = $combo.options().get().filter((opt) => $(opt).data('disabled') === true).map((opt) => $(opt).val());
			if (disabledOptions.length > 0) {
				$combo.disableOptions(disabledOptions, false);
			}

			$combo.on('change', function(event) {
				oSettings.onChange(event, $combo);
			});
			if (oSettings.keepList) {
				$combo.data('full-list', options);
			}
			if (oSettings.keepProviderData) {
				$combo.data('full-data', data.aaData);
			}
			if (!oSettings.noSort) {
				$combo.sortOptions(oSettings.sorting);
			}

			//oSettings.optionExtraData = oSettings.optionExtraData.length > 0 ? oSettings.optionExtraData : ['percIva'];
			/* this code is needed for storing in option.data some extra properties read from json row */
			if (oSettings.optionExtraData.length > 0) {
				var validOptions = $.grep($combo.options(), function(opt) { return opt.value !== ''; });
				$.each(oSettings.optionExtraData, function(i, extraProp) {
					var values = {};
					$.each(data.aaData, function(i, opt) {
						values['kp_' + opt[keyProperty]] = opt[extraProp];
					})
					$.each(validOptions, function(i, option) {
						var v = values['kp_' + option.value];
						$(option).data(extraProp, v); // deprecated: to be remeoved once not used any more
						$(option).data('extra-' + extraProp, v);
					})
				})
			}

			if (oSettings.initialValue != undefined) {
				$combo.selectOptions(oSettings.initialValue);
			} else {
				if (!oSettings.ignoreIsSelectedAttribute) {
					var initialList = [];
					$.each(data.aaData, function(i, k) {
						var isSelected = k.isSelected && ($.isTrue(k.isSelected));
						if (isSelected) {
							initialList.push(k[keyProperty]);
						}
					});
					if (initialList.length > 0) {
						$combo.selectOptions(initialList);
					}
				}
			}
			$.each($combo.selectedOptions(), function(i, option) {
				var $opt = $(option);
				if (($opt.attr('value') !== undefined) && ($opt.data('disabled') != true)) {
					$opt.data('initially-selected', true);
				}
			});
			deferred.resolve($combo);
		});
	}
}